import { render, staticRenderFns } from "./DropOutCulrocSuspension.vue?vue&type=template&id=78c6e3a8&scoped=true&"
import script from "./DropOutCulrocSuspension.vue?vue&type=script&lang=js&"
export * from "./DropOutCulrocSuspension.vue?vue&type=script&lang=js&"
import style0 from "./DropOutCulrocSuspension.vue?vue&type=style&index=0&id=78c6e3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6e3a8",
  null
  
)

export default component.exports